import { render, staticRenderFns } from "./ewallet.vue?vue&type=template&id=cb6c7f28&scoped=true"
import script from "./ewallet.vue?vue&type=script&lang=js"
export * from "./ewallet.vue?vue&type=script&lang=js"
import style0 from "./ewallet.vue?vue&type=style&index=0&id=cb6c7f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6c7f28",
  null
  
)

export default component.exports